import { useLazyQuery } from '@apollo/client/react';

import { LIST_DOCUMENTS_AVAILABILITY } from '../queries/ListDocuments';
import { LoggerContextProps } from '../types/LogContext';
import { DocumentData } from '../types/Documents';
import { handleError } from './errorHandler';

export function useListDocumentAvailability() {
  const context: LoggerContextProps = {
    action: 'listDocumentAvailability',
    caseId: '',
  };
  const [listDocumentAvailabilityQuery, { data, loading, error }] = useLazyQuery<{
    listDocuments: { items: DocumentData[] };
  }>(LIST_DOCUMENTS_AVAILABILITY, {
    fetchPolicy: 'network-only',
  });

  const fetchDocumentAvailability = async (id: string) => {
    context.caseId = id;
    try {
      await listDocumentAvailabilityQuery({
        variables: {
          filter: {
            case_id: id,
          },
        },
      });
    } catch (error) {
      handleError(error, context, `Failed to list documents availability.`);
    }
  };

  return {
    fetchDocumentAvailability,
    data,
    loading,
    error,
  };
}
